import { useQuery } from "@tanstack/react-query";

async function generateClientLoginLinkRequest(
  email: string,
  slug: string,
): Promise<string> {
  const response = await fetch(
    `${import.meta.env.VITE_AGENCY_API_URL}login/link`,
    {
      method: "POST",
      headers: {
        "Content-Type": `application/json`,
      },
      body: JSON.stringify({
        email,
        slug,
      }),
    },
  );
  if (response.ok) {
    const data = await response.json();
    return data.magic_link;
  } else {
    throw new Error("Error generating login link");
  }
}

export default function useClientLoginUrl(email: string, slug: string) {
  const {
    isLoading: isGeneratingLoginUrl,
    data: loginUrl,
    error: loginUrlError,
  } = useQuery({
    queryKey: ["clientLoginLink", email, slug],
    queryFn: () => generateClientLoginLinkRequest(email, slug),
  });

  return {
    loginUrl,
    isGeneratingLoginUrl,
    loginUrlError,
  };
}
